import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Outlet } from "react-router-dom"

import PageTitle from "widgets/common/PageTitle"
import { getAlertsTabsConfig } from "helpers/config/tabs/alertsTabsConfig"
import useDateRange from "helpers/hooks/useDateRange"
import LinkTabsSection from "widgets/common/LinkTabsSection"
import useDocumentTitle from "helpers/hooks/useDocumentTitle"

function Alerts() {
  const { t } = useTranslation()
  const { getDateRangeTools } = useDateRange()
  const { searchParams: eventsSearchParams } = getDateRangeTools("events")

  useDocumentTitle(t("pageTitles.ALERTS"))

  const alertsTabsConfig = useMemo(
    () => getAlertsTabsConfig(eventsSearchParams),
    [eventsSearchParams],
  )

  return (
    <>
      <PageTitle text={t("pageTitles.ALERTS")} styles={{ mb: 2 }} />
      <LinkTabsSection tabsConfig={alertsTabsConfig} />
      <Outlet />
    </>
  )
}

export default Alerts
